import {
  Cloud, Mail, Users, FolderSync, ShieldCheck,
  UserCog, LifeBuoy, MonitorSmartphone, Wifi, Globe,
} from "lucide-react";

export const SERVICES = [
  {
    icon: Cloud,
    title: "Microsoft 365",
    desc: "Setup, migration and ongoing support for your entire Microsoft 365 environment.",
  },
  {
    icon: Mail,
    title: "Email & Mailboxes",
    desc: "Outlook, email and shared mailbox configuration done right, first time.",
  },
  {
    icon: Users,
    title: "Microsoft Teams",
    desc: "Teams setup, configuration and troubleshooting for smooth collaboration.",
  },
  {
    icon: FolderSync,
    title: "OneDrive & SharePoint",
    desc: "File management, syncing and access support across your organisation.",
  },
  {
    icon: ShieldCheck,
    title: "Security & MFA",
    desc: "MFA, spam protection and account security to keep your business safe.",
  },
  {
    icon: UserCog,
    title: "Accounts & Devices",
    desc: "User account creation, device setup and everyday admin support.",
  },
  {
    icon: LifeBuoy,
    title: "General IT Support",
    desc: "Troubleshooting and IT support for both home and business users.",
  },
  {
    icon: MonitorSmartphone,
    title: "Hardware Support",
    desc: "PCs, laptops, printers and peripherals — diagnosed and fixed.",
  },
  {
    icon: Wifi,
    title: "Networking & Wi-Fi",
    desc: "Wi-Fi setup, routers and connectivity issues resolved fast.",
  },
  {
    icon: Globe,
    title: "DNS Configuration",
    desc: "SPF, DKIM and DMARC alignment support for reliable email delivery.",
  },
];

export const SERVICE_OPTIONS = [
  "Microsoft 365 Setup & Migration",
  "Outlook, Email & Shared Mailboxes",
  "Microsoft Teams",
  "OneDrive & SharePoint",
  "Security, MFA & Spam Protection",
  "User Accounts & Device Setup",
  "General IT Support",
  "Hardware Support",
  "Networking & Wi-Fi",
  "DNS Configuration (SPF/DKIM/DMARC)",
  "Other / Not Sure",
];

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_stotttech-support/artifacts/zv4r478g_Stott%20Tech%20Logo.png";
